<mat-form-field appearance="fill" class="w-full">
    <mat-label>Search for a location</mat-label>
    <input aria-label="Search for address" placeholder="Start typing..." type="text" matInput [formControl]="searchControl" [matAutocomplete]="auto">
    <mat-autocomplete #auto="matAutocomplete" [displayWith]="displayFn.bind(this)" (optionSelected)="onSelectPrediction($event.option.value)">
      <mat-option *ngFor="let suggestion of suggestions" [value]="suggestion">
        {{ suggestion.description }}
      </mat-option>
    </mat-autocomplete>
  </mat-form-field>